import React from 'react';
import {
    Breadcrumbs,
    Content,
    Link,
    InfoCard,
    StructuredMetadataTable,
    TabbedLayout,
    Table,
    TableColumn,
} from '@backstage/core-components';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Popover from '@material-ui/core/Popover';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { ContainerLogView } from '../ContainerLogView';

import { useForensicDetails } from '../../hooks/useForensicDetails';
import { useRouteRef, useRouteRefParams } from '@backstage/core-plugin-api';
import { rootRouteRef, detailRouteRef } from '../../routes';
import { Box, Card, CardContent, Divider, Grid, Typography } from '@material-ui/core';

const columns: TableColumn[] = [
    {
        title: 'Type',
        field: 'type',
        sorting: true,
        highlight: true,
        cellStyle: (_, rowData: any & { tableData: { id: number } }) => {
            return rowData.type === 'Normal'
                ? {
                    color: '#6CD75F',
                }
                : {
                    color: '#DC3D5A',
                };
        },
    },
    {
        title: 'Timestamp',
        field: 'lastTimestamp',
        //    dateSetting: {
        //      format: 'yyyy-MM-dd HH:mm:ss',
        //    },
        defaultSort: 'desc',
        sorting: true,
    },
    {
        title: 'Count',
        field: 'count',
        sorting: true,
    },
    {
        title: 'Reason',
        field: 'reason',
        sorting: true,
    },
    {
        title: 'Message',
        field: 'message',
        sorting: true,
    },
];

export const DetailedView = () => {
    const { itemRef, pod, container } = useRouteRefParams(detailRouteRef);

    const [{ value }] = useForensicDetails({ itemRef });
    const rootRouteLink = useRouteRef(rootRouteRef);

    const containerTabs = value?.manifest.pods[0].status.containerStatuses
        .map((cs, index) => {
            return (
                <TabbedLayout.Route path={index === 0 ? '/main' : `/${cs.name}`} title={cs.name} key={`container-tab-${index}`}>
                    <ContainerLogView itemRef={itemRef} pod={value?.manifest.pods[0].podName} container={cs.name} />
                </TabbedLayout.Route>
            );
        });

    const initContainerTabs = value?.manifest.pods[0].status.initContainerStatuses
        .map((cs, index) => {
            return (
                <TabbedLayout.Route path={`/${cs.name}`} title={`${cs.name} (init)`} key={`init-container-tab-${index}`}>
                    <ContainerLogView itemRef={itemRef} pod={value?.manifest.pods[0].podName} container={cs.name} />
                </TabbedLayout.Route>
            );
        });

    const startupProbeResponseInfo = value?.startupProbe.httpResponse ? {
        'Status': `${value.startupProbe.httpResponse.statusCode} ${value.startupProbe.httpResponse.statusReason}`,
        'Body': value.startupProbe.httpResponse.body,
        'Log': value.startupProbe.httpResponse.log,
    } : {};

    return (
        <>
            <Breadcrumbs>
                <Link to={rootRouteLink()}>Failed Deployments</Link>
                <Typography>{value?.manifest.createdAt} - {value?.manifest.namespace}</Typography>
            </Breadcrumbs>

            <Grid container>
                <Grid item xs={12}>
                    {containerTabs && (
                    <TabbedLayout>
                        {containerTabs}
                        {initContainerTabs}
                    </TabbedLayout>
                    )}
                </Grid>
                <Grid item xs={9}>
                    <Table title="Pod Events" columns={columns} data={value?.selectedPodEvents || []} options={{ padding: 'dense' }} />
                </Grid>
                <Grid item xs={3}>
                    <InfoCard title="Startup Probe">
                        <Content>
                            <Card variant="outlined">
                                <CardContent>
                                    {value?.startupProbe.execCmd && (
                                        <Typography>CMD <pre>{value.startupProbe.execCmd}</pre></Typography>
                                    )}
                                    {value?.startupProbe.httpPath && (
                                        <Typography>HTTP GET &rarr; localhost:{value.startupProbe.httpPort}{value.startupProbe.httpPath}</Typography>
                                    )}
                                </CardContent>
                            </Card>
                            <StructuredMetadataTable metadata={startupProbeResponseInfo} />
                        </Content>
                    </InfoCard>
                </Grid>
            </Grid>

        </>
    );
}
